import { call } from "redux-saga/effects";
import { API_URL } from "../_config";
import { CallApi } from "./api/callApi";

// export function* getGenderList(action: any): any {
//   try {
//     const data = action.payload;
//     const resp = yield call(CallApi.GET, API_URL.COMMON.GENDER_LIST, data, false);

//     if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data) {

//       action && action.callbackSuccess && action.callbackSuccess(resp.data);
//     } else {
//       action && action.callbackError && action.callbackError(resp.data);
//     }
//   } catch (e) {
//     action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
//   }
// }

export function* getCountries(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.COMMON.COUNTRIES, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getStates(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.COMMON.STATES + "/" + data.countryId + "/" + data.type, null, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* getCities(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.GET, API_URL.COMMON.CITIES + "/" + data.stateId, null, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}

export function* newsletterSignup(action: any): any {
  try {
    const data = action.payload;
    const resp = yield call(CallApi.POST, API_URL.COMMON.NEWSLETTER_SIGNUP, data, true);
    if (resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
      action && action.callbackSuccess && action.callbackSuccess(resp.data);
    } else {
      action && action.callbackError && action.callbackError(resp.data);
    }
  } catch (e: any) {
    action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
  }
}
